const initialState = {
  selectedUsers: [],
  role: "NONE",
  activateNotifications: false,
  activateCarteNotifications: false,
  activateCalendarNotifications: false,

  dashboard: {
    allowAccess: false
  },

  /**
   * allowViewDataBy options:
   * - No access: 0
   * - All: 1
   * - Personal: 10
   * - Partnership: 11
   * - BU: 100
   * - Zone: 101
   * - Backup: 110
   */

  clients: {
    allowAccess: false,
    allowViewDataBy: 0,
    allowUpdateBudgetConfig: false,
    allowUpdateClientSettings: false
  },

  collaborators: {
    allowAccess: false,
    allowConfigCollaborator: false,
    allowViewDataBy: 0,
    allowAccessCPr: false,
    allowAccessPlans: false,
    // drag and drop
    allowDragFromToDo: false,
    allowDragFromWIP: false,
    allowDragFromValidate: false,
    allowDragFromDone: false,
    allowAccessCalendar: false,
    allowValidateVacationRequest: false,
    allowAccessPlanification: false,
    allowAccessFolderCapacity: false,
    allowAccessFinancialState: false,
    allowAddBinomEvent: false
  },

  prestations: {
    allowAccess: false,
    allowViewDataBy: 0
  },

  notifications: {
    allowAccess: false,
    supervision: {
      allowAccess: false,
      allowViewDataFor: [],
      allowViewDataBy: []
    },
    validationRequestSupervision: {
      allowAccess: false,
      allowViewDataFor: [],
      allowViewDataBy: []
    },
    supervisionRepport: {
      allowAccess: false,
      allowViewDataFor: [],
      allowViewDataBy: []
    },
    attachmentRequest: {
      allowAccess: false,
      allowViewDataFor: [],
      allowViewDataBy: []
    },
    absenceRequest: {
      allowAccess: false,
      allowViewDataFor: [],
      allowViewDataBy: []
    },
    absenceAssignment: {
      allowAccess: false,
      allowViewDataFor: [],
      allowViewDataBy: []
    },
    absenceBackup: {
      allowAccess: false,
      allowViewDataFor: [],
      allowViewDataBy: []
    },
    sickLeave: {
      allowAccess: false,
      allowViewDataFor: [],
      allowViewDataBy: []
    },
    absenceStatus: {
      allowAccess: false,
      allowViewDataFor: [],
      allowViewDataBy: []
    },
    tsReminder: {
      allowAccess: false,
      allowViewDataFor: [],
      allowViewDataBy: []
    },
    forfait: {
      allowAccess: false,
      allowViewDataFor: [],
      allowViewDataBy: []
    },
    clientToAttribut: {
      allowAccess: false,
      allowViewDataFor: [],
      allowViewDataBy: []
    },
    budgetIncomplet: {
      allowAccess: false,
      allowViewDataFor: [],
      allowViewDataBy: []
    },
    newClient: {
      allowAccess: false,
      allowViewDataFor: [],
      allowViewDataBy: []
    },
    clientRisk: {
      allowAccess: false,
      allowViewDataFor: [],
      allowViewDataBy: []
    },
    clientRecovered: {
      allowAccess: false,
      allowViewDataFor: [],
      allowViewDataBy: []
    },
    clientDepart: {
      allowAccess: false,
      allowViewDataFor: [],
      allowViewDataBy: []
    }
  },

  financial: {
    allowAccess: false,

    // financial state
    financialState: {
      allowAccess: false,
      allowViewDataBy: 0
    },
    forfait: {
      allowAccess: false,
      allowLaunchRevision: false
    },
    // croissance
    croissance: {
      allowAccess: false,
      allowViewDataBy: 0,
      allowAccessIN: false,
      allowAccessOUT: false,
      allowAccessToMonitor: false,
      allowAccessLeaving: false
    },
    dynamicTable: {
      allowAccess: false,
      allowViewDataBy: 0
    }
  },

  reporting: {
    allowAccess: false,
    // suivi de production
    production: {
      allowAccess: false,
      allowViewDataBy: 0
    },
    // développement individuel
    individualDevBe: {
      allowAccess: false,
      allowViewDataBy: 0
    },
    individualDevMa: {
      allowAccess: false,
      allowViewDataBy: 0
    },
    // suivi d'échéances
    echeance: {
      allowAccess: false,
      allowViewDataBy: 0
    },
    // récap bilan
    recapBalance: {
      allowAccess: false,
      allowViewDataBy: 0
    },
    // calendrier
    calendar: {
      allowAccess: false,
      allowViewDataBy: 0
    },
    // suivi de temps de travail
    timesheet: {
      allowAccess: false,
      allowViewDataBy: 0
    },
    // suivi de portefeuille
    portfolio: {
      allowAccess: false,
      allowViewDataBy: 0
    },
    // supervision
    supervision: {
      allowAccess: false,
      allowViewDataBy: 0
    },
    // matrice de congé
    vacation: {
      allowAccess: false,
      allowViewDataBy: 0
    },
    // plans
    plans: {
      allowAccess: false,
      allowViewDataBy: 0
    },
    // suivi des prestation
    prestations: {
      allowAccess: false,
      allowViewDataBy: 0
    }
  },

  capacityPlanning: {
    allowAccess: false,
    allowViewDataBy: 0
  },

  settings: {
    allowAccess: false,
    allowAccessCategories: false,
    allowAccessTaskTypes: false,
    allowAccessCollaborators: false,
    allowAccessCalendar: false,
    allowAccessModels: false,
    allowAccessUsers: false,
    allowAccessSynchronization: false,
    allowAccessParameters: false
  },

  timesheet: {
    allowAccess: false,
    allowViewDataBy: 0
  },

  allowConfigurateBudget: false,
  allowUpdatingBillingView: false,
  allowUpdatingTarifClients: false,
  allowUpdatingNewClients: false,
  allowUpdatingDepartClients: false,
  allowAccessToClientCollaboratorRelation: false,
  allowAccessToClientInformations: false,
  allowAccessToGlobalBudget: false,
  allowUpdatingOffrePrice: false,
  allowToAddDeleger: false,
  allowUpdateBudgetedBenchmark: false,
  allowAccessToStatisticsCards: false,
  allowAccessToCorrectionCards: false,
  allowVisualizationOfBudgetedTime: false,
  allowVisualizationOfBudgetedBenchmark: false,
  allowVisualizationOfRealizedTime: false,
  allowVisualizationOfRealizedBenchmark: false,

  allowAdjustDistributionOfTasksByRole: false,
  allowAttributionBU: false,
  allowAttributionSquad: false,
  allowCollabToDevCard: false,
  allowAttributionCluster: false,
  allowSelectAppliedModel: false,
  allowTodragAndDropFromTODO: false,
  allowTodragAndDropFromWIP: false,
  allowTodragAndDropFromDONE: false,
  allowTodragAndDropFromVALIDATION: false,

  allowAccessClientSpace: false,
  allowAccessToClientList: false,
  allowCreateCorrectionCards: false,
  allowAccessToCollaboratorList: false,

  allowAccessReporting: false,
  allowAccessReportingTab: false,
  allowAccessProductionCapacity: false,
  allowAccessBonusPlan: false,
  allowAccessEcheance: false,
  allowAccessBalanceRecap: false,
  allowAccessCalendar: false,
  allowAccessTimeReport: false,
  allowAccessPortfolio: false,
  allowAccessErrReporting: false,
  allowAccessVacationMatrix: false,
  allowAccessPlans: false,
  allowAccessPrestation: false,

  allowAccessPrestaTS: false,
  allowAccessFinancial: false,
  allowAccessFinancialSheet: false,
  allowAccessForfait: false,
  allowAccessCroissance: false,
  allowAccessDynamicTable: false,

  allowAccessCapacityPlanning: false,
  allowAccessCapacityPlanningTab: false,
  allowAccessSynthesis: false,

  allowAccessSetting: false,
  allowAccessCategorySetting: false,
  allowAccessTaskTypeSetting: false,
  allowAccessCollaboratorSetting: false,
  allowAccessCalendarSetting: false,
  allowCoefficientsConfig: false,
  allowAccessModelSetting: false,
  allowAccessUserSetting: false,
  allowAccessSynchronization: false,
  allowAccessParameterSetting: false,

  filter: {
    role: "ALL",
    searchWord: ""
  }
};

export const authorizationsSettingsReducer = (state = initialState, action) => {
  switch (action.type) {
    case "INIT_USERS_SETTINGS": {
      return initialState;
    }
    case "SET_SELECTED_USERS": {
      return { ...state, selectedUsers: action.selectedUsers };
    }
    case "SET_ROLE": {
      return { ...state, role: action.role };
    }
    case "SELECT_ROLE": {
      return { ...state, filter: { ...state.filter, role: action.role } };
    }
    case "SELECT_SEARCH_WORD": {
      return {
        ...state,
        filter: { ...state.filter, searchWord: action.searchWord }
      };
    }
    case "SET_DEFAULT_AUTH_PARAMS": {
      return {
        ...state,
        ...action.params
      };
    }
    case "SET_ALLOW_CONFIGURATE_BUDGET": {
      return {
        ...state,
        allowConfigurateBudget: action.allowConfigurateBudget
      };
    }
    case "SET_UPDATE_BILLING_VIEW": {
      return {
        ...state,
        allowUpdatingBillingView: action.allowUpdatingBillingView
      };
    }
    case "SET_UPDATE_TARIF_CLIENT": {
      return {
        ...state,
        allowUpdatingTarifClients: action.allowUpdatingTarifClients
      };
    }
    case "SET_UPDATE_NEW_CLIENT": {
      return {
        ...state,
        allowUpdatingNewClients: action.allowUpdatingNewClients
      };
    }
    case "SET_UPDATE_DEPART_CLIENT": {
      return {
        ...state,
        allowUpdatingDepartClients: action.allowUpdatingDepartClients
      };
    }
    case "SET_ALLOW_ACCESS_TO_CLIENT_COLLABORATOR_RELATION": {
      return {
        ...state,
        allowAccessToClientCollaboratorRelation:
          action.allowAccessToClientCollaboratorRelation
      };
    }
    case "SET_ALLOW_ACCESS_TO_CLIENT_INFORMATION": {
      return {
        ...state,
        allowAccessToClientInformations: action.allowAccessToClientInformations
      };
    }
    case "SET_ALLOW_ACCESS_TO_GLOBAL_BUDGET": {
      return {
        ...state,
        allowAccessToGlobalBudget: action.allowAccessToGlobalBudget
      };
    }
    case "SET_ALLOW_UPDATEING_OFFER_PRICE": {
      return {
        ...state,
        allowUpdatingOffrePrice: action.allowUpdatingOffrePrice
      };
    }
    case "SET_ALLOW_TO_ADD_DLEGER": {
      return {
        ...state,
        allowToAddDeleger: action.allowToAddDeleger
      };
    }
    case "SET_ALLOW_UPDATE_BUDGET_BENCHMARK": {
      return {
        ...state,
        allowUpdateBudgetedBenchmark: action.allowUpdateBudgetedBenchmark
      };
    }
    case "SET_ALLOW_ACCESS_TO_STATISTICS_CARDS": {
      return {
        ...state,
        allowAccessToStatisticsCards: action.allowAccessToStatisticsCards
      };
    }
    case "SET_ALLOW_ACCESS_TO_CORRECTION_CARDS": {
      return {
        ...state,
        allowAccessToCorrectionCards: action.allowAccessToCorrectionCards
      };
    }
    case "SET_ALLOW_VISUALIZATION_OF_BUDGETED_TIME": {
      return {
        ...state,
        allowVisualizationOfBudgetedTime:
          action.allowVisualizationOfBudgetedTime
      };
    }
    case "SET_ALLOW_VISUALIZATION_OF_BUDGETED_BENCHMARK": {
      return {
        ...state,
        allowVisualizationOfBudgetedBenchmark:
          action.allowVisualizationOfBudgetedBenchmark
      };
    }
    case "SET_ALLOW_VISUALIZATION_OF_REALIZED_TIME": {
      return {
        ...state,
        allowVisualizationOfRealizedTime:
          action.allowVisualizationOfRealizedTime
      };
    }
    case "SET_ALLOW_VISUALIZATION_OF_REALIZED_BENCHMARK": {
      return {
        ...state,
        allowVisualizationOfRealizedBenchmark:
          action.allowVisualizationOfRealizedBenchmark
      };
    }

    case "SET_ALLOW_ADJUST_DISTRIBUTION_OF_TASKS_BY_ROLE": {
      return {
        ...state,
        allowAdjustDistributionOfTasksByRole:
          action.allowAdjustDistributionOfTasksByRole
      };
    }
    case "SET_ALLOW_ATTRIBUTION_BU": {
      return {
        ...state,
        allowAttributionBU: action.allowAttributionBU
      };
    }
    case "SET_ALLOW_ATTRIBUTION_SQUAD": {
      return {
        ...state,
        allowAttributionSquad: action.allowAttributionSquad
      };
    }
    case "SET_ALLOW_COLLAB_TO_DEV_CARD": {
      return {
        ...state,
        allowCollabToDevCard: action.allowCollabToDevCard
      };
    }
    case "SET_ALLOW_ATTRIBUTION_CLUSTER": {
      return {
        ...state,
        allowAttributionCluster: action.allowAttributionCluster
      };
    }
    case "SET_ALLOW_SELECT_APPLIED_MODEL": {
      return {
        ...state,
        allowSelectAppliedModel: action.allowSelectAppliedModel
      };
    }
    case "SET_ALLOW_TO_DRAG_AND_DROP_FROM_TODO": {
      return {
        ...state,
        allowTodragAndDropFromTODO: action.allowTodragAndDropFromTODO
      };
    }
    case "SET_ALLOW_TO_DRAG_AND_DROP_FROM_WIP": {
      return {
        ...state,
        allowTodragAndDropFromWIP: action.allowTodragAndDropFromWIP
      };
    }
    case "SET_ALLOW_TO_DRAG_AND_DROP_FROM_DONE": {
      return {
        ...state,
        allowTodragAndDropFromDONE: action.allowTodragAndDropFromDONE
      };
    }
    case "SET_ALLOW_TO_DRAG_AND_DROP_FROM_VALIDATION": {
      return {
        ...state,
        allowTodragAndDropFromVALIDATION:
          action.allowTodragAndDropFromVALIDATION
      };
    }

    case "SET_ACTIVATE_NOTIFICATIONS": {
      return {
        ...state,
        activateNotifications: action.activateNotifications
      };
    }
    case "SET_ACTIVATE_CALENDAR_NOTIFICATIONS": {
      return {
        ...state,
        activateCalendarNotifications: action.activateCalendarNotifications
      };
    }
    case "SET_ACTIVATE_CARTE_NOTIFICATIONS": {
      return {
        ...state,
        activateCarteNotifications: action.activateCarteNotifications
      };
    }
    case "SET_ALLOW_ACCESS_CLIENT_SPACE": {
      return {
        ...state,
        allowAccessClientSpace: action.allowAccessClientSpace
      };
    }
    case "SET_ALLOW_ACCESS_CLIENT_LIST": {
      return {
        ...state,
        allowAccessToClientList: action.allowAccessToClientList
      };
    }
    case "SET_ALLOW_ACCESS_COLLABORATOR_LIST": {
      return {
        ...state,
        allowAccessToCollaboratorList: action.allowAccessToCollaboratorList
      };
    }
    case "SET_ALLOW_CREATE_CORRECTION_CARDS": {
      return {
        ...state,
        allowCreateCorrectionCards: action.allowCreateCorrectionCards
      };
    }
    case "SET_ALLOW_ACCESS_REPORTING": {
      return {
        ...state,
        allowAccessReporting: action.allowAccessReporting
      };
    }
    case "SET_ALLOW_ACCESS_REPORTING_TAB": {
      return {
        ...state,
        allowAccessReportingTab: action.allowAccessReportingTab
      };
    }
    case "SET_ALLOW_ACCESS_PRODUCTION_CAPACITY": {
      return {
        ...state,
        allowAccessProductionCapacity: action.allowAccessProdCapacity
      };
    }
    case "SET_ALLOW_ACCESS_BONUS_PLAN": {
      return {
        ...state,
        allowAccessBonusPlan: action.allowAccessBonusPlan
      };
    }
    case "SET_ALLOW_ACCESS_ECHEANCE": {
      return {
        ...state,
        allowAccessEcheance: action.allowAccessEcheance
      };
    }
    case "SET_ALLOW_ACCESS_BALANCE_RECAP": {
      return {
        ...state,
        allowAccessBalanceRecap: action.allowAccessBalanceRecap
      };
    }
    case "SET_ALLOW_ACCESS_CALENDAR": {
      return {
        ...state,
        allowAccessCalendar: action.allowAccessCalendar
      };
    }
    case "SET_ALLOW_ACCESS_TIME_REPORT": {
      return {
        ...state,
        allowAccessTimeReport: action.allowAccessTimeReport
      };
    }
    case "SET_ALLOW_ACCESS_PORTFOLIOS": {
      return {
        ...state,
        allowAccessPortfolio: action.allowAccessPortfolio
      };
    }
    case "SET_ALLOW_ACCESS_ERROR_REPORTING": {
      return {
        ...state,
        allowAccessErrReporting: action.allowAccessErrReporting
      };
    }
    case "SET_ALLOW_ACCESS_VACATION_MATRIX": {
      return {
        ...state,
        allowAccessVacationMatrix: action.allowAccessVacationMatrix
      };
    }
    case "SET_ALLOW_ACCESS_PLANS": {
      return {
        ...state,
        allowAccessPlans: action.allowAccessPlan
      };
    }
    case "SET_ALLOW_ACCESS_PRESTATIONS": {
      return {
        ...state,
        allowAccessPrestation: action.allowAccessPrestation
      };
    }
    case "SET_ALLOW_ACCESS_PRESTA_TS": {
      return {
        ...state,
        allowAccessPrestaTS: action.allowAccessPrestaTS
      };
    }
    case "SET_ALLOW_ACCESS_FINANCIAL": {
      return {
        ...state,
        allowAccessFinancial: action.allowAccessFinancial
      };
    }
    case "SET_ALLOW_ACCESS_FINANCIAL_SHEET": {
      return {
        ...state,
        allowAccessFinancialSheet: action.allowAccessFinancialSheet
      };
    }
    case "SET_ALLOW_ACCESS_FORFAIT": {
      return {
        ...state,
        allowAccessForfait: action.allowAccessForfait
      };
    }
    case "SET_ALLOW_ACCESS_CROISSANCE": {
      return {
        ...state,
        allowAccessCroissance: action.allowAccessCroissance
      };
    }
    case "SET_ALLOW_ACCESS_DYNAMIC_TABLE": {
      return {
        ...state,
        allowAccessDynamicTable: action.allowAccessDynamicTab
      };
    }
    case "SET_ALLOW_ACCESS_CAPACITY_PLANNING": {
      return {
        ...state,
        allowAccessCapacityPlanning: action.allowAccessCapPlan
      };
    }
    case "SET_ALLOW_ACCESS_CAPACITY_PLANNING_TAB": {
      return {
        ...state,
        allowAccessCapacityPlanningTab: action.allowAccessCapPlanTab
      };
    }
    case "SET_ALLOW_ACCESS_SYNTHESIS": {
      return {
        ...state,
        allowAccessSynthesis: action.allowAccessSynt
      };
    }
    case "SET_ALLOW_ACCESS_SETTING": {
      return {
        ...state,
        allowAccessSetting: action.allowAccessSetting
      };
    }
    case "SET_ALLOW_ACCESS_CATEGORY_SETTING": {
      return {
        ...state,
        allowAccessCategorySetting: action.allowAccessCategorySetting
      };
    }
    case "SET_ALLOW_ACCESS_TASK_TYPE_SETTING": {
      return {
        ...state,
        allowAccessTaskTypeSetting: action.allowAccessTaskTypeSetting
      };
    }
    case "SET_ALLOW_ACCESS_COLLABORATOR_SETTING": {
      return {
        ...state,
        allowAccessCollaboratorSetting: action.allowAccessCollaboratorSetting
      };
    }
    case "SET_ALLOW_ACCESS_CALENDAR_SETTING": {
      return {
        ...state,
        allowAccessCalendarSetting: action.allowAccessCalendarSetting
      };
    }
    case "SET_ALLOW_COEFFICIENTS_CONFIG_SETTING": {
      return {
        ...state,
        allowCoefficientsConfig: action.allowCoefficientsConfig
      };
    }
    case "SET_ALLOW_ACCESS_MODEL_SETTING": {
      return {
        ...state,
        allowAccessModelSetting: action.allowAccessModelSetting
      };
    }
    case "SET_ALLOW_ACCESS_USER_SETTING": {
      return {
        ...state,
        allowAccessUserSetting: action.allowAccessUserSetting
      };
    }
    case "SET_ALLOW_ACCESS_SYNCHRONIZATION": {
      return {
        ...state,
        allowAccessSynchronization: action.allowAccessSynchronization
      };
    }
    case "SET_ALLOW_ACCESS_PARAMETER_SETTING": {
      return {
        ...state,
        allowAccessParameterSetting: action.allowAccessParameterSetting
      };
    }

    // new access setting
    case "SET_ALLOW_ACCESS": {
      const { page, key, value } = action.payload;
      return {
        ...state,
        [page]: {
          ...state[page],
          [key]: value
        }
      };
    }
    case "SET_ALLOW_SUB_ACCESS": {
      const { page, subPage, key, value } = action.payload;
      return {
        ...state,
        [page]: {
          ...state[page],
          [subPage]: {
            ...state[page][subPage],
            [key]: value
          }
        }
      };
    }
    case "RESET_ALLOW_ACCESS": {
      return {
        ...state,
        [action.page]: {
          ...initialState[action.page]
        }
      };
    }
    case "RESET_ALLOW_SUB_ACCESS": {
      const { page, subPage } = action.payload;
      return {
        ...state,
        [page]: {
          ...state[page],
          [subPage]: {
            ...initialState[page][subPage]
          }
        }
      };
    }
    case "TOGGLE_VIEW_DATA_BY":
      return {
        ...state,
        [action.page]: {
          ...state[action.page],
          allowViewDataBy: state[action.page].allowViewDataBy === 0 ? 1 : 0
        }
      };
    case "TOGGLE_VIEW_SUB_DATA_BY":
      const { page, subPage } = action.payload;
      return {
        ...state,
        [page]: {
          ...state[page],
          [subPage]: {
            ...state[page][subPage],
            allowViewDataBy: state[page][subPage].allowViewDataBy === 0 ? 1 : 0
          }
        }
      };
    case "TOGGLE_VIEW_SUB_DATA_LIST_BY":
      let { payload } = action;
      return {
        ...state,
        [payload.page]: {
          ...state[payload.page],
          [payload.subPage]: {
            ...state[payload.page][payload.subPage],
            allowViewDataBy:
              state[payload.page][payload.subPage].allowViewDataBy.length === 0
                ? [1]
                : []
          }
        }
      };
    case "TOGGLE_VIEW_SUB_DATA_LIST_FOR":
      let payl = action.payload;
      return {
        ...state,
        [payl.page]: {
          ...state[payl.page],
          [payl.subPage]: {
            ...state[payl.page][payl.subPage],
            allowViewDataFor:
              state[payl.page][payl.subPage].allowViewDataFor.length === 0
                ? [10]
                : []
          }
        }
      };
    case "SET_ALLOW_VIEW_DATA_BY": {
      const { page, option } = action.payload;
      return {
        ...state,
        [page]: {
          ...state[page],
          allowViewDataBy: parseInt(option, 10)
        }
      };
    }
    case "SET_ALLOW_VIEW_SUB_DATA_BY": {
      const { page, subPage, option } = action.payload;
      return {
        ...state,
        [page]: {
          ...state[page],
          [subPage]: {
            ...state[page][subPage],
            allowViewDataBy: parseInt(option, 10)
          }
        }
      };
    }
    case "SET_ALLOW_VIEW_SUB_DATA_LIST_FOR": {
      const { page, subPage, option } = action.payload;
      return {
        ...state,
        [page]: {
          ...state[page],
          [subPage]: {
            ...state[page][subPage],
            allowViewDataFor: option
          }
        }
      };
    }
    case "SET_ALLOW_VIEW_SUB_DATA_LIST_BY": {
      const { page, subPage, option } = action.payload;
      return {
        ...state,
        [page]: {
          ...state[page],
          [subPage]: {
            ...state[page][subPage],
            allowViewDataBy: option
          }
        }
      };
    }
    default:
      return state;
  }
};



// WEBPACK FOOTER //
// ./src/reducers/authorizations-settings.js